
// Single source of truth for the auth token cookie.
//
// The cookie is shared across the CMS host and the preview host (e.g.
// daisy.comparamais.pt and preview.comparamais.pt), so it's scoped to the
// registrable base domain derived from DAISY_CMS_URL. Secure is added only on
// HTTPS so http dev still works; SameSite=Strict keeps it first-party.

const BASE_DOMAIN = (process.env.DAISY_CMS_URL || '').match(/([a-z0-9-]+\.[a-z0-9-]+)$/i)?.[1]

function cookieAttrs() {
	const attrs = ['path=/', 'SameSite=Strict']
	if (BASE_DOMAIN) attrs.push(`domain=.${BASE_DOMAIN}`)
	if (typeof window !== 'undefined' && window.location.protocol === 'https:') attrs.push('Secure')
	return attrs
}

export function setTokenCookie(token, days = 30) {
	const date = new Date()
	date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
	document.cookie = [`token=${token}`, `expires=${date.toUTCString()}`, ...cookieAttrs()].join('; ')
}

export function clearTokenCookie() {
	// Domain + path must match the set cookie, or the browser won't remove it.
	document.cookie = ['token=', 'expires=Thu, 01 Jan 1970 00:00:00 GMT', ...cookieAttrs()].join('; ')
}
